import { httpService } from './http'
const teamRoute = 'handle-team/'

export const teamService = {
    createTeam,
    createDepartment,
    deleteTeam,
    deleteDepartment,
    editTeam,
    getTeamsForAdmin,
    removeMemberFromDepartment,
    deleteInvite,
    sendInvite,
    deleteTeamMember,
    editMemberRole,
    getTeamVideos,
    addMembersToDepartment,
}

async function createTeam(details) {
    const team = await httpService.post(teamRoute + 'create-team', details)
    return team
}

async function createDepartment(department, teamId) {
    const newDepartment = await httpService.post(teamRoute + 'create-department', { department, teamId })
    return newDepartment
}

async function deleteTeam(teamId) {
    const confirm = await httpService.delete(teamRoute + 'delete-team', { teamId })
    return confirm
}

async function deleteDepartment(name, teamId, videos) {
    const confirm = await httpService.delete(teamRoute + 'delete-department', { name, teamId, videos })
    return confirm
}

async function editTeam(change, teamId) {
    const confirm = await httpService.put(teamRoute + 'edit-team-details', { change, teamId })
    return confirm
}

async function getTeamsForAdmin() {
    const teams = await httpService.get(teamRoute + 'get-teams-for-admin')
    return teams
}

async function deleteInvite(inviteToId, teamId) {
    const confirm = await httpService.delete(teamRoute + 'delete-invite/', { inviteToId, teamId })
    return confirm
}

async function sendInvite(email, roles, teamId) {
    const invite = await httpService.post(teamRoute + 'send-invite', { email, roles, teamId })
    return invite
}

async function deleteTeamMember(memberId, teamId, videos) {
    const confirm = await httpService.delete(teamRoute + 'delete-team-member/', { memberId, teamId, videos })
    return confirm
}

async function removeMemberFromDepartment(memberId, teamId, departmentName) {
    const confirm = await httpService.delete(teamRoute + 'remove-member-from-department', { memberId, teamId, departmentName })
    return confirm
}

async function getTeamVideos(teamId) {
    const videos = await httpService.post(teamRoute + 'get-team-videos/', { teamId })
    return videos
}

async function editMemberRole(_id, teamId, roles) {
    const confirm = await httpService.put(teamRoute + 'edit-member-role', { _id, roles, teamId })
    return confirm
}

async function addMembersToDepartment(membersIds, teamId, departmentName) {
    const confirm = await httpService.post(teamRoute + 'add-members-to-department', { membersIds, teamId, departmentName })
    return confirm
}



